import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChatBotAuthorizeService } from '../../shared/services/chat-bot-auth.service';

export const chatBotAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authorizeService = inject(ChatBotAuthorizeService);

  const shouldHandle =
    req.url.includes(environment.apiBot) && !req.url.includes('token');

  if (shouldHandle) {
    return authorizeService.getToken().pipe(
      switchMap((token) => {
        const authRequest = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + token),
        });
        return next(authRequest);
      })
    );
  }

  return next(req);
};
